import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import { ReactNode } from "react"

function TooltipContainer({ children, tooltip, triggerStyling, className, side, delayDuration }: { children: ReactNode, triggerStyling?: string, tooltip: string, className?: string, side?: "top" | "left" | "right" | "bottom", delayDuration?: number }) {
  return (
    <TooltipProvider delayDuration={delayDuration}>
      <Tooltip>
        <TooltipTrigger className={triggerStyling}>{children}</TooltipTrigger>
        <TooltipContent side={side} className={`dark:bg-zinc-800 dark:text-zinc-100 ${className}`}>
          {tooltip}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>

  )
}

export default TooltipContainer